export default __webpack_public_path__ + "static/media/file-manager.63430567.svg";